import { createFileRoute } from "@tanstack/react-router";
import { MarketingContentPage } from "../components/marketing/MarketingContentPage";
import { contentHead, loadContentPage } from "../marketing-content/load";

export const Route = createFileRoute("/blog_/category/ai-news")({
  loader: () => loadContentPage("/blog/category/ai-news"),
  head: ({ loaderData }) => contentHead(loaderData),
  component: ContentRoute,
});

function ContentRoute() {
  return <MarketingContentPage page={Route.useLoaderData()} />;
}
